import React from "react";
import GraphicCalendarNotesPlatformed from 'features/CalendarView/GraphicCalendarNotes'
import GraphicCalendarNotePlatformed from 'features/CalendarView/GraphicCalendarNotes/GraphicCalendarNote'
export default function GraphicCalendarNotes({ data, isWhiteBlack }) {
  function renderCalNote({calNote, i, getPosition}){
    if (calNote.color_type === 'red') return null;
    let position = null
    if (calNote.color_type === 'green'){
      position = getPosition(calNote);
    } 
    return (
      <GraphicCalendarNotePlatformed
        colorType={calNote.color_type}
        {...{position, isWhiteBlack}}
        key={calNote.name + "-" + i}
      />
    );
  }
  const calNotes =
    data.calendarNotes &&
    data.calendarNotes.map((calNote, i) => {
      return renderCalNote({
        ...{calNote, i},
        getPosition: (cn) => (cn.duration === 1) ? "single" : "starting"
      })
    });
  const contCalNotes =
    data.continuingCalendarNotes &&
    data.continuingCalendarNotes.map((calNote, i) => {
      return renderCalNote({
        ...{calNote, i},
        getPosition: (ccn) => (ccn.duration === ccn.current_day) ? "ending" : "continuing"
      })
    });
  return (
    <GraphicCalendarNotesPlatformed
      {...{calNotes, contCalNotes}}
    />
  );
}